import React from 'react';
import PersistentDrawerLeft from '../../components/seller/Sidebar';
import UpdateEmail from '../../components/updateEmail';
export default function SellerUpdateEmailPage() {
  const [userData, setUser] = React.useState({});

  return (
    <div>
      <PersistentDrawerLeft userData={setUser} components={<UpdateEmail userData={userData} />} titleAppBar={'Ubah Email'} />
    </div>
  );
}